document.addEventListener('DOMContentLoaded', function () {
	// Local video: click play button to load <video>
	document.querySelectorAll('.video-stats__player[data-video-src] .video-stats__play-btn').forEach(function (btn) {
		btn.addEventListener('click', function (e) {
			e.stopPropagation();
			var player = btn.closest('.video-stats__player');
			var src = player.getAttribute('data-video-src');
			var video = document.createElement('video');
			video.className = 'video-stats__video';
			video.controls = true;
			video.autoplay = true;
			video.playsInline = true;
			video.style.cssText = 'width:100%;height:100%;object-fit:cover;border-radius:10px;display:block;';
			video.src = src;
			player.innerHTML = '';
			player.style.position = 'relative';
			player.appendChild(video);
		});
	});

	// Embed video (YouTube/Vimeo with poster): click play button to load iframe
	document.querySelectorAll('.video-stats__player[data-embed] .video-stats__play-btn').forEach(function (btn) {
		btn.addEventListener('click', function (e) {
			e.stopPropagation();
			var player = btn.closest('.video-stats__player');
			var embedHtml = player.getAttribute('data-embed');
			player.innerHTML = embedHtml;
			var iframe = player.querySelector('iframe');
			if (iframe) {
				iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:0;border-radius:10px;';
				var src = iframe.getAttribute('src') || '';
				if (src.indexOf('autoplay') === -1) {
					iframe.setAttribute('src', src + (src.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1');
				}
			}
		});
	});
});
